import { ReactComponent as InfoIcon } from "../../../../assets/svg/icons/info.svg";
import { parseUtcDate } from "../../../../utils/date/formatedDate";
import "./styles.css";

type TableVisualizationRowProps = {
  evaluation: ITaskEvaluation;
  setSelectedId: (e: number) => void;
};

export default function TableVisualizationRowTask({
  evaluation,
  setSelectedId
}: TableVisualizationRowProps) {
  const formatDateTimeByLocale = (date: Date | null) => {
    if (!date || Number.isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const datePart = `${day}/${month}/${year}`;

    const timePart = new Intl.DateTimeFormat(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).format(date);

    return (
      <>
        {datePart}
        <br />
        {timePart}
      </>
    );
  };

  const created = parseUtcDate(evaluation?.created_at);
  const updated = parseUtcDate(evaluation?.updated_at);
  const synced = parseUtcDate(evaluation?.synced_at);

  return (
    <tr>
      <td>{evaluation.name}</td>
      <td>{evaluation.task}</td>
      <td>{evaluation.micro_area_initials && !evaluation.micro_area_initials.includes("LT") ? evaluation.micro_area_initials : ""}</td>
      <td>{evaluation.micro_area_initials && evaluation.micro_area_initials.includes("LT") ? evaluation.micro_area_initials : ""}</td>
      <td>{evaluation.status}</td>
      <td>
        {evaluation?.created_at ?
          formatDateTimeByLocale(created)
          :
          ""}
      </td>
      <td>
        {evaluation?.updated_at ?
          formatDateTimeByLocale(updated)
          :
          evaluation.status == "Concluído" ? formatDateTimeByLocale(created) : ""
        }
      </td>
      <td>
        {formatDateTimeByLocale(synced)}
      </td>
      <td className="infoButton">
        <button title="Ver detalhes" style={{
          display: evaluation.status == "Concluído" ? "block" : "none",
          backgroundColor: "transparent"
        }}>
          <InfoIcon
            onClick={() => {
              setSelectedId(evaluation.id)
            }}
          />
        </button>
      </td>
    </tr>
  );
}
